import { useAxiosInterceptors } from "../../config/axios";
import { AxiosInstance } from "axios";



export const addAuthToHeader = async (headers: any) => {
  // TODO IF NO WORKSPACE ID GET IT?
  return { ...headers }

}
export class BaseModuleMobileApi {
  basePath = '';
  axiosInstance: AxiosInstance | undefined;

  constructor() {
    this.axiosInstance = useAxiosInterceptors();
  }

  async getList(offset: number, limit: number, headers: any, filters: any, orderby: any, configOptions?: any, params?: any,) {
    const response = await this.axiosInstance!.get(`/mobile/${this.basePath}`, { params: { offset, limit, ...orderby, ...filters, ...params }, headers: await addAuthToHeader(headers ?? {}), ...configOptions });
    return response.data;
  };

  async get(rowIdSlug: number | string, headers: any, configOptions?: any) {
    const response = await this.axiosInstance!.get(`/mobile/${this.basePath}/${rowIdSlug}`, { headers: await addAuthToHeader(headers ?? {}), ...configOptions });
    return response.data;
  };

  async create(data: any, headers: any, configOptions?: any) {
    const response = await this.axiosInstance!.post(`/mobile/${this.basePath}`, data, { headers: await addAuthToHeader(headers ?? {}), ...configOptions });
    return response.data;
  };
};
